// server/cart/inquiry.service.ts
import { ApiService } from "@/lib/api.service";
import type {
    InquirySubmitPayload,
    InquirySubmitResponse,
} from "@/types/inquiry";

class InquiryServiceClass extends ApiService {
    /**
     * ثبت درخواست استعلام → ذخیره در جدول orders
     * روت لاراول: POST /v1/order/inquiry (نیازمند ورود کاربر)
     */
    async submit(payload: InquirySubmitPayload): Promise<InquirySubmitResponse> {
        const response = await this.post("/order/inquiry", payload);
        return response.data;
    }
}

export const InquiryService = new InquiryServiceClass();
